import * as profileEvents from "../../store/events/profile";
import Box from "@mui/material/Box";
import Button from "../../components/Button/Button";
import ErrorMessages from "../../components/ErrorMessages/ErrorMessages";
import FormTextField from "../../components/Form/FormTextField";
import React from "react";
import TaskHeader from "../../components/Task/TaskHeader";
import TaskTemplate from "../templates/TaskTemplate";
import { connect } from "react-redux";
import useNavigateQSA from "../../utils/hooks/useNavigateQSA";
import {
	Form,
	isArrayOfLength,
	isObject
} from "@pheaa/channels-component-library";
import {
	HTML_ATTR_PATTERN_EMAIL,
	SYSTEM_ERROR_MESSAGE_400,
	getErrorMessageForCode
} from "../../config/common";

const EditContactEmailView = ({ title, ...props }) => {

	let contactEmailObj = null;

	const {
		contactsEmailsErrors,
		contactsEmailsIsLoading,
		profileData,
		updateContactsEmails
	} = props;

	const navigate = useNavigateQSA();

	if (isObject(profileData) && isObject(profileData.contacts) && isArrayOfLength(profileData.contacts.emails)) {
		contactEmailObj = profileData.contacts.emails.find(emailObj => emailObj.id === "contact");
	}

	const handleSubmit = (e, formData) => {
		updateContactsEmails([{
			id: "contact",
			isValid: true,
			...formData
		}], () => {
			navigate("/profile");
		});
	};

	return (
		<TaskTemplate>
			<TaskHeader
				closeCallback={() => { profileEvents.clearErrors(); }}
				closeTaskDestination="/profile"
				title={title}
			/>
			<Form
				id="defaultFormNarrow"
				onSubmit={handleSubmit}
			>
				<Box mt={6}>
					<ErrorMessages
						errorMessages={contactsEmailsErrors.map(error => {
							return { ...error, message: getErrorMessageForCode(error.code, { 400: { message: SYSTEM_ERROR_MESSAGE_400 } }) };
						})}
					/>
					<Box mt={2.5}>
						<FormTextField
							name="email"
							pattern={HTML_ATTR_PATTERN_EMAIL}
							required={true}
							title="Contact Email"
							value={contactEmailObj?.email}
						/>
						<Box
							mb={1.75}
							mt={5.625}
						>
							<Button
								disabled={contactsEmailsIsLoading}
								processing={contactsEmailsIsLoading}
								type="submit"
								variant="contained"
							>
								Save
							</Button>
						</Box>
					</Box>
				</Box>
			</Form>
		</TaskTemplate>
	);
};

const mapStateToProps = state => ({
	contactsEmailsErrors: state.profile.contactsEmailsErrors,
	contactsEmailsIsLoading: state.profile.contactsEmailsIsLoading,
	profileData: state.profile.data
});

const mapDispatchToProps = dispatch => ({
	updateContactsEmails: (data, onSuccess) => dispatch(profileEvents.updateContactsEmails(data, onSuccess))
});

export default connect(mapStateToProps, mapDispatchToProps)(EditContactEmailView);